import { render, staticRenderFns } from "./ViewButton.vue?vue&type=template&id=deeba7d2&scoped=true&"
import script from "./ViewButton.ts?vue&type=script&lang=ts&"
export * from "./ViewButton.ts?vue&type=script&lang=ts&"
import style0 from "./ViewButton.scss?vue&type=style&index=0&id=deeba7d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deeba7d2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
